// CompositeComponent.js
import React, { useState } from 'react';
import { View } from 'react-native';

const RadioView = ({ children, wrap=false, style, select }:{children: any, wrap?: any, style?: any, select?:any}) => {
  const [selectedView, setSelectedView] = useState(null);

  const handleSelectView = (view: any) => {
    setSelectedView(view);
    select(view)
  };

  const viewStyle = wrap ? {
    flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between'
  }:{
    flexDirection: 'column'
  }

  return (
    <View style={style} >
      <View style={{...viewStyle}}>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          onSelectView: handleSelectView,
          isSelected: child.props.title === selectedView,
        });
      })}
    </View>
    </View>
  );
};

export default RadioView;
